@use '@ingka/variables/style.scss' as *;

.header {
  margin-block-end: $space-150;
  font-size: $font-size-500;
}

.button {
  margin-block: $space-150;
}

.divider {
  display: flex;
  align-items: center;
  width: 100%;
  gap: $space-100;

  &::before,
  &::after {
    content: '';
    flex-grow: 1;
    height: 1px;
    background-color: $colour-neutral-4;
  }
}

.menuSheetsModal {
  overflow: hidden;
}

.loyaltyColor {
  color: $colour-static-ikea-family;
}

.benefits {
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: $space-50;
    align-items: center;
  }
}

.createFamilyAccountText {
  margin-block: $space-150 0;
}
